<template>
    <form
        class="form-login"
        @submit="onFormSubmit($event, formView)"
    >
        <div class="form-login-header">
            <p class="form-login-title">{{formData.title}}</p> 
            <div class="error-login">
                <div :class="{  'opacity-1 error-msg': loginError, 'error-msg': !loginError }">
                    <i class="dx-icon-info"></i>
                    <p>{{formData.errorMsg}}</p>
                </div>
            </div>
        </div>
        <!-- 
          -- ¿Separamos en componentes?
          -- Vista LOGIN
         -->
        <div v-if="formView==='login'">
            <div class="form-login-body">
                    <DxTextBox
                        id="user"
                        placeholder="Usuario"
                        v-model="c_user_login"
                        @option-changed="fieldValidation($event, formView)"
                        :element-attr="{class: 'textbox'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                        </DxValidator>
                    </DxTextBox>
                    <DxTextBox
                        id="password"
                        v-model:mode="passwordMode"
                        v-model="c_user_password"
                        @option-changed="fieldValidation($event, formView)"
                        placeholder="Contraseña"
                        :element-attr="{class: 'textbox'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                        </DxValidator>
                        <DxTextBoxButton
                            :options="passwordButton"
                            name="password"
                            location="after"
                        />
                    </DxTextBox>
                    <DxTextBox 
                        id="source"
                        placeholder="Origen de ingreso"
                        v-model="source"
                        @option-changed="fieldValidation($event, formView)"
                        :element-attr="{class: 'textbox textbox--ph-black'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                        </DxValidator>
                    </DxTextBox>
            </div>
            <div class="form-login-footer">
                <div class="form-actions">
                    <div class="checkbox-container">
                        <DxCheckBox
                            v-model:value="userSaved"
                        />
                        <label>Recordarme</label>
                    </div>
                    <div class="link-container">
                        <a href="#" @click="changeFormView('recover')">Recuperar contraseña</a>
                    </div>
                </div>
                <DxButton 
                    text="Ingresar"
                    type="normal"
                    styling-mode="outlined"
                    :element-attr="{ class: 'btn-login' }"
                    :use-submit-behavior="true"
                    :disabled="loginDisable"
                />
                
            </div>
        </div>
        <!-- 
          -- Vista RECUPERAR CONTRASEÑA 1
         -->
        <div v-if="formView==='recover'">
            <div class="form-login-body">
                    <DxTextBox
                        v-model:value="c_user_email"
                        @option-changed="fieldValidation($event, formView)"
                        placeholder="Ingrese su email"
                        :element-attr="{class: 'textbox'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                            <DxEmailRule 
                                message="Formato de email inválido."
                            />
                        </DxValidator>
                    </DxTextBox>
                    <p class="help-text">Te enviaremos un código a tu casilla de correo.</p>
            </div>
            <div class="form-login-footer" style="display: flex;">
                <!-- :disabled="true" -->
                <DxButton 
                    icon="back"
                    type="normal"
                    styling-mode="outlined"
                    :element-attr="{ class: 'btn-back' }"
                    @click="changeFormView('login')"
                />
                <DxButton 
                    text="Enviar código"
                    type="normal"
                    styling-mode="outlined"
                    :element-attr="{ class: 'btn-login' }"
                    :use-submit-behavior="true"
                    :disabled="recoverDisable"
                />
            </div>
        </div>
        <!-- 
          -- Vista RECUPERAR CONTRASEÑA 2
         -->
         <div v-if="formView==='recover-2'">
            <div class="form-login-body">
                    <DxTextBox
                        id="newPassword"
                        v-model:mode="passwordMode"
                        v-model:value="recoverData.newPassword"
                        placeholder="Nueva contraseña"
                        @option-changed="fieldValidation($event, formView)"
                        :element-attr="{class: 'textbox'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                        </DxValidator>
                        <DxTextBoxButton
                            :options="passwordButton"
                            name="password"
                            location="after"
                        />
                    </DxTextBox>
                    <div class="validation-container" style="color: #fff">
                    <div class="validation-item">
                        <i
                            v-if="passwordValidation.length" 
                            class="fas fa-check-circle"
                        ></i>
                        <i 
                            v-else
                            class="far fa-circle"
                        ></i>
                        <span>Mínimo 6 caracteres.</span>
                    </div>
                    <div class="validation-item">
                        <i
                            v-if="passwordValidation.upperChar" 
                            class="fas fa-check-circle"
                        ></i>
                        <i 
                            v-else
                            class="far fa-circle"
                        ></i>
                        <span>Mínimo 1 mayúscula.</span>
                    </div>
                    <div class="validation-item">
                        <i
                            v-if="passwordValidation.lowerChar" 
                            class="fas fa-check-circle"
                        ></i>
                        <i 
                            v-else
                            class="far fa-circle"
                        ></i>
                        <span>Mínimo 1 minúscula.</span>
                    </div>
                    <div class="validation-item">
                        <i
                            v-if="passwordValidation.number" 
                            class="fas fa-check-circle"
                        ></i>
                        <i 
                            v-else
                            class="far fa-circle"
                        ></i>
                        <span>Mínimo 1 número.</span>
                    </div>
                </div>
                    <DxTextBox
                        id="newPassword2"
                        v-model:mode="passwordMode"
                        v-model:value="recoverData.newPassword2"
                        placeholder="Confirme nueva contraseña"
                        @option-changed="fieldValidation($event, formView)"
                        :element-attr="{class: 'textbox'}"
                        :disabled="newPassword2Field"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                            <DxCompareRule
                                :comparison-target="()=> recoverData.newPassword"
                                message="Las contraseñas no coinciden."
                            />
                        </DxValidator>
                        <DxTextBoxButton
                            :options="passwordButton"
                            name="password"
                            location="after"
                        />
                    </DxTextBox>
                    <DxTextBox
                        id="vCode"
                        v-model:value="recoverData.vCode"
                        placeholder="Código de verificación"
                        @option-changed="fieldValidation($event, formView)"
                        :element-attr="{class: 'textbox'}"
                    >
                        <DxValidator>
                            <DxRequiredRule 
                                message="Este campo es obligatorio."
                            />
                        </DxValidator>
                    </DxTextBox>
                    <p class="help-text">El código a ingresar fue enviado a la casilla de correo sandra@gmail.com</p>
            </div>
            <div class="form-login-footer">
                <!-- :disabled="true" -->
                <div class="form-login-footer-action" style="display: flex;">
                    <DxButton 
                    icon="back"
                    type="normal"
                    styling-mode="outlined"
                    :element-attr="{ class: 'btn-back' }"
                    @click="changeFormView('login')"
                />
                <DxButton 
                    text="Ingresar"
                    type="normal"
                    styling-mode="outlined"
                    :element-attr="{ class: 'btn-login' }"
                    :use-submit-behavior="true"
                    :disabled="newPasswordDisabled"
                />
                </div>                
            </div>
        </div>
    </form>
</template>

<script>
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxButton from 'devextreme-vue/button';
import { ref } from '@vue/reactivity';
import { computed, onMounted } from '@vue/runtime-core';
import { DxRequiredRule, DxValidator, DxEmailRule, DxCompareRule } from 'devextreme-vue/validator';
import { useRouter } from 'vue-router';
import { DxToast } from 'devextreme-vue/toast';
import { useStore } from 'vuex';




export default {
    name: 'FormLogin',
    components: {
        DxTextBox,
        DxCheckBox,
        DxButton,
        DxTextBoxButton,
        DxRequiredRule,
        DxValidator,
        DxToast,
        DxEmailRule,
        DxCompareRule
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        const recoverDisable = ref(true);
        const loginDisable = ref(true);
        const c_user_login = ref('');
        const c_user_password = ref('');
        const c_user_email = ref('');
        //REDEFINIR ORIGEN
        const source = ref('');
        const passwordMode = ref('password');
        const loginError = ref(false);
        const userSaved = ref(false);
        const formView = ref('login');

        const recoverData = ref({
            newPassword:'',
            newPassword2: '',
            vCode: ''
        });

        const newPassword2Field = ref(true);

        const passwordValidation = ref({
            length: false,
            upperChar: false,
            lowerChar: false,
            number: false
        });
        
        const newPasswordDisabled = ref(true);

        onMounted( () =>{

            if(localStorage.loginData){
                userSaved.value = true
                let data = JSON.parse(localStorage.loginData);

                c_user_login.value = data.user;
                source.value = data.source;
            }

        });
        /**
         * COMPUTED PROPERTIES
         */

        const passwordButton = computed( () => {

            let icon = passwordMode.value === 'text' ? 
                '../icons/eye-solid.svg' : 
                '../icons/eye-slash-solid.svg';
            
            return {
                icon: icon,
                type: 'normal',
                stylingMode: 'text',
                onClick: () => {
                    passwordMode.value = passwordMode.value === 'text' ? 'password' : 'text';            
                }
            }

        });

        const formData = computed( ()=> {
            
            let data = {};
            switch (formView.value) {
                case 'login':
                    data.title = 'Ingresar a mi cuenta';
                    data.errorMsg = 'Error de ingreso, verifique sus datos.'
                    break;
                case 'recover':
                    data.title = 'Recuperar Contraseña';
                    data.errorMsg = 'Usuario no encontrado.'
                    break;
                case 'recover-2':
                    data.title = 'Recuperar Contraseña';
                    data.errorMsg = 'Código de verificación incorrecto.'
                    break;
            
                default:
                    break;
            }
            return data;

        });

        /**
         * METHODS
         */

            const onFormSubmit = (e, view) => {

                e.preventDefault();
                // console.log(loginData.value);

                // return

                switch (view) {
                    case 'login':
                        if(userSaved.value){
                            localStorage.setItem('loginData', JSON.stringify(
                                {
                                    user: c_user_login.value,
                                    source: source.value,
                                }
                            ))
                        } else {
                            localStorage.removeItem('loginData');
                        }

                        /**
                         * Usuario harcodeado.
                         */

                        if(c_user_login.value === 'Sandra' && c_user_password.value === '123456' && source.value === 'E1') {
                            loginError.value = false;
                            console.log('login OK');
                            store.dispatch('login/changeUserLogin', c_user_login.value);
                            store.dispatch('login/changeUserPassword', c_user_password.value);
                            store.dispatch('login/changeSource', source.value);
                            store.dispatch('login/changeTsLogin', Date.now());
                            router.push('/backoffice');
                        } else { loginError.value = true; }

                        break;

                    case 'recover':
                        /**
                         * Mail hardcodeado para simular el recupero.
                         */
                        if(c_user_email.value.toLowerCase() === "sandra@gmail.com") {
                            console.log('codigo enviado al mail');
                            loginError.value = false;
                            changeFormView('recover-2')
                        } else { loginError.value = true; }
                        break;
                    case 'recover-2':
                        /**
                         * Codigo hardcodeado ¿?.
                         */
                        if(recoverData.value.vCode === '1234') {
                            router.push('/backoffice');
                        } else { loginError.value = true }
                        break;
                    default:
                        break;
                }
                
            };

            /**
             * TEST
             */
                
                const changeFormView = (view) => {

                    loginError.value = false;
                    c_user_password.value = '';
                    c_user_email.value = '';
                    recoverData.value = {}; 
                    formView.value = view;

                };

                const fieldValidation = (e, view) => {
                    if(e.name === 'text') {
                            switch (view) {
                            case 'recover-2':
                                if(e.element.id === 'newPassword') {
                                    passwordValidation.value.length = /^.{6,}$/.test(e.value);
                                    passwordValidation.value.upperChar = /[A-Z]/.test(e.value);
                                    passwordValidation.value.lowerChar = /[a-z]/.test(e.value);
                                    passwordValidation.value.number = /[0-9]/.test(e.value);    
                                }
                                let passwordOk = !Object.values(passwordValidation.value).includes(false)
                                if(passwordOk) {
                                    newPassword2Field.value = false;

                                    if(e.element.id === 'newPassword2') {
                                        if(e.value.length != 0) {
                                            newPasswordDisabled.value = recoverData.value.vCode ? false : true; ;
                                        } else { newPasswordDisabled.value = true; }
                                    }

                                    if(e.element.id === 'vCode') {
                                        if(e.value.length != 0) {
                                            newPasswordDisabled.value = recoverData.value.newPassword2 ? false : true;
                                        } else { newPasswordDisabled.value = true; }
                                    }

                                } else { 
                                    newPassword2Field.value = true;
                                    newPasswordDisabled.value = true;
                                 }
                                break;
                            case 'recover':
                                if(e.value.length === 0) {
                                    recoverDisable.value = true;
                                } else { recoverDisable.value = false; }
                                break;

                            case 'login':
                                if(e.element.id === 'user') {
                                    if(e.value.length != 0) {
                                        loginDisable.value = c_user_password.value != '' && source.value != '' ? false : true
                                    }else { loginDisable.value = true }
                                }
                                if(e.element.id === 'password') {
                                    if(e.value.length != 0) {
                                        loginDisable.value = c_user_login.value != '' && source.value != '' ? false : true
                                    }else { loginDisable.value = true }
                                }
                                if(e.element.id === 'source') {
                                    if(e.value.length != 0) {
                                        loginDisable.value = c_user_login.value != '' && c_user_password.value != '' ? false : true
                                    }else { loginDisable.value = true }
                                }
                                break;
                            
                            default:
                                break;
                        }
                    }

                }

                const comparePassword = () => {
                    return newPassword.value;
                }

        return {
            passwordMode, 
            passwordButton,
            onFormSubmit,
            // loginData,
            loginError,
            loginDisable,
            userSaved,
            formView,
            changeFormView,
            recoverDisable,
            formData,
            // test,
            // userEmail,
            recoverData,
            passwordValidation,
            comparePassword,
            newPassword2Field,
            newPasswordDisabled,
            // removeWhiteSpace
            c_user_login,
            c_user_password,
            c_user_email,
            source,
            fieldValidation
        }
    }
}
</script>

<style>
    .form-login {
        width: 300px;
    }
    
    .form-login-header {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
    }

    .form-login-header img {
        width: 100%;
    }

    .form-login-header .form-login-title {
        color: #fff;
        font-size: 24px;
        margin-top: 20px;
    }

    .form-login-body .textbox {
        margin-bottom: 16px;
        width: 300px;
    }

    .form-login-footer {
        text-align: center;
    }

    .form-login-footer .checkbox-container {
        display: flex;
        align-items: center;
    }

    .form-login-footer .checkbox-container label {
        margin-left: 6px;
    }

    .form-login-footer label {
        color: #fff;
    }

    .form-login-footer .link-container * {
        color: #fff;
    }

    .form-login-footer .form-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
    }

    .form-login .btn-login {
        color: #fff;
        width: 100%;
    }

    .form-login .btn-back {
        margin-right: 6px;
    }
    
    .form-login .btn-back .dx-icon {
        color: #fff !important;
    }

    .form-login .error-login {
        margin: 8px 0;
        height: 30px;
        width: 100%;
    }
    
    .form-login .error-msg {
        background-color: #d9534f;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px 0;
        border-radius: 6px;
        opacity: 0;
    }

    .form-login .error-msg i {
        font-size: 18px;
        margin-right: 6px;
    }
    
    .form-login .error-msg p {
        font-weight: 500;
        margin-right: 6px;
    }

    .form-login .opacity-1 {
        opacity: 1;
    }
    
    .form-login .help-text {
        color: #fff;
        /* text-align: center; */
        margin: -10px 0 20px 0;
    }

    .form-login .validation-container {
        margin-top: -10px;
        margin-bottom: 6px;
        margin-left: 6px;
    }

    .form-login .validation-item {
        display: flex;
        align-items: center;
        padding: 2px 0;
    }

    .form-login .validation-item i {
        font-size: 16px;
        margin-right: 6px;
    }

    /* .form-login .validation-item .fas{
        color: #5cb85c;
    } */

    .form-login .validation-item span {
        font-size: 14px;
    }
</style>